export const ERROR_MESSAGES = [
  "invalid_vendor_identifier",
  "already_claimed",
  "vendor_not_found",
  "api_key_invalid",
  "api_key_missing",
  "over_rate_limit",
]